import React from 'react'
import { t } from 'ttag'

import { Form } from 'components/shared/Form/Form'
import { InfiniteScroll } from 'components/shared/InfiniteScoll/InfiniteScroll'
import { LabelWithTooltip } from 'components/shared/LabelWithTooltip/LabelWithTooltip'
import { TemplateCard } from 'components/shared/TemplateCard/TemplateCard'

import { SEARCH_NAME_FIELD } from './model'

import styles from './TemplateSearch.module.scss'

type TemplateSearchProps = {
  activeTemplate?: { id?: string | number } | null
  control?: any
  templates?: any[]
  handleActiveTemplate: (template: any) => void
  isPending?: boolean
}

export const TemplateSearch = React.forwardRef<
  HTMLLIElement,
  TemplateSearchProps
>(
  (
    { activeTemplate, control, templates, handleActiveTemplate, isPending },
    ref,
  ) => (
    <aside className={styles.templates}>
      <header className={styles.header}>
        <LabelWithTooltip
          className={styles.templateHeader}
          tooltip={t`A list of existing templates for jobs.`}
        >
          {t`Templates`}
        </LabelWithTooltip>
        <Form>
          <Form.Field
            className={styles.input}
            field="input"
            name={SEARCH_NAME_FIELD}
            placeholder={t`Search...`}
            {...{ control }}
          />
        </Form>
      </header>
      <InfiniteScroll {...{ isPending }}>
        {(templates ?? []).map((template, index) => (
          <InfiniteScroll.Item
            key={template.id}
            ref={templates?.length === index + 1 ? ref : null}
          >
            <TemplateCard
              onClick={() => handleActiveTemplate(template)}
              isActive={activeTemplate?.id === template.id}
            >
              {template.name}
            </TemplateCard>
          </InfiniteScroll.Item>
        ))}
      </InfiniteScroll>
    </aside>
  ),
)
